
import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./groups.css";
import { useNavigate } from "react-router-dom";

function ClassGroups() {
  const [groups, setGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newGroup, setNewGroup] = useState("");
  const [assignedFees, setAssignedFees] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [groupIcon, setGroupIcon] = useState(null);
  const [groupIconPreview, setGroupIconPreview] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchGroups();
  }, []);

  // Fetch all groups
  const fetchGroups = async () => {
    try {
      const res = await axios.get("https://bodhimaram.onrender.com/group/groups");
      const groupsData = res.data;
      // Fetch member counts for all groups
      const updatedGroups = await Promise.all(
        groupsData.map(async (g) => {
          try {
            const membersRes = await axios.get(
              `https://bodhimaram.onrender.com/api/students/${g.group_code}`
            );
            return {
              ...g,
              members_count: Array.isArray(membersRes.data)
                ? membersRes.data.length
                : 0,
            };
          } catch (err) {
            console.error(`Error fetching members for ${g.name}:`, err);
            return { ...g, members_count: 0 };
          }
        })
      );
      setGroups(updatedGroups);
    } catch (err) {
      console.error("Error fetching groups:", err);
      toast.error("❌ Failed to load groups");
    }
  };

  // Add new group
  const addGroup = async () => {
    if (!newGroup) {
      toast.warn("⚠️ Group name cannot be empty!");
      return;
    }

    try {
      const timeOption = fromTime && toTime ? `${fromTime}-${toTime}` : null;

      const formData = new FormData();
      formData.append("name", newGroup);
      formData.append("assigned_fees", assignedFees || 0);
      formData.append("status", "active");
      formData.append("time_option", timeOption);
      if (groupIcon) formData.append("icon", groupIcon);

      await axios.post("https://bodhimaram.onrender.com/group/groups", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("✅ Group created successfully!");

      setNewGroup("");
      setAssignedFees("");
      setFromTime("");
      setToTime("");
      setGroupIcon(null);
      setGroupIconPreview(null);
      setShowModal(false);

      fetchGroups();
    } catch (err) {
      console.error("Error adding group:", err);
      toast.error("❌ Failed to add group. Try again!");
    }
  };

  const filteredGroups = groups.filter((g) =>
    g.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="groups-container">
      <ToastContainer position="top-right" autoClose={3000} />

      <main className="groups-main">
        <div className="groups-header">
          <h2>Groups</h2>
         <div className="groups-actions">

  <div className="groups-filter-row">
    <input
      type="text"
      placeholder="🔍 Search"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

    <select>
      <option>Active</option>
      <option>Inactive</option>
    </select>
  </div>

  <button
    className="new-group-btn"
    onClick={() => setShowModal(true)}
  >
    + New Group
  </button>

</div>


        </div>

        <div className="groups-grid">
          {filteredGroups.map((g) => (
            <div
              className="group-card"
              key={g.id}
              onClick={() =>
                navigate(`/dashboard/group-details/${g.group_code}`)
              }
              style={{ cursor: "pointer" }}
            >
              <div className="group-header">
                <img
                  src={
                    g.icon
                      ? `https://bodhimaram.onrender.com${g.icon}`
                      : "/default-profile.png"
                  }
                  alt="group icon"
                  className="group-icon"
                />
                <h4>{g.name}</h4>
              </div>
              <p>{g.members_count || 0} Members</p>
              <hr />
              {/* <div className="due">
                <span>Due Amount</span>
                <strong>₹{g.due || 0}</strong>
              </div> */}
            </div>
          ))}
        </div>
      </main>

      {showModal && (
        <div className="group-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-group" onClick={(e) => e.stopPropagation()}>
            <h3>Create New Group</h3>

            <input
              type="text"
              value={newGroup}
              onChange={(e) => setNewGroup(e.target.value)}
              placeholder="Enter Group/Class name"
            />

            <input
              type="number"
              value={assignedFees}
              onChange={(e) => setAssignedFees(e.target.value)}
              placeholder="Enter Assigned Fees"
            />

            {/* Image Upload with Preview and Remove */}
            <div className="upload-field">
              <label>Group Icon</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setGroupIcon(file);
                  setGroupIconPreview(file ? URL.createObjectURL(file) : null);
                }}
              />
              {groupIconPreview && (
                <div className="image-preview-wrapper">
                  <img
                    src={groupIconPreview}
                    alt="Preview"
                    className="preview-icon"
                  />
                  <button
                    type="button"
                    className="remove-preview-btn"
                    onClick={() => {
                      setGroupIcon(null);
                      setGroupIconPreview(null);
                    }}
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>

            <div className="time-range">
              <label>Time</label>
              <div className="time-inputs">
                <input
                  type="time"
                  value={fromTime}
                  onChange={(e) => setFromTime(e.target.value)}
                />
                <span>to</span>
                <input
                  type="time"
                  value={toTime}
                  onChange={(e) => setToTime(e.target.value)}
                />
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="ok-btn" onClick={addGroup}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClassGroups;
